import type { ReactNode } from "react";
import { LegalHeader } from "./LegalHeader";
import type { DocMeta } from "./types";

export function LegalLayout({
  meta,
  children,
}: {
  meta: DocMeta;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-white">
      <LegalHeader
        title={meta.title}
        subtitle={meta.subtitle}
        maxWidthClassName="max-w-4xl"
      />

      {/* Content */}
      <main id="main" className="max-w-4xl mx-auto px-6 py-16">
        <div className="prose prose-lg max-w-none">
          <p className="text-lg font-medium text-gray-700 mb-8">
            <strong>Last Updated:</strong> {meta.lastUpdated}
          </p>
          {children}
        </div>
      </main>
    </div>
  );
}
